import React from 'react'
import { Helmet } from 'react-helmet'
import { StaticQuery, graphql } from 'gatsby'
import HeaderMobile from './header-mobile'

const Layout = ({ children, title, description, keywords, layoutClassName, layoutStyle }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
            description
          }
        }
      }
    `}
    render={(data) => {
      const { siteMetadata } = data.site
      const pageTitle = title || siteMetadata.title
      const pageDescription = description || siteMetadata.description
      const pageKeywords = keywords || siteMetadata.keywords
      const logoUrl = "https://i.postimg.cc/J4Lr7Sgd/westview-golf-logo.png"
      const siteUrl = typeof window !== 'undefined' ? window.location.href : 'https://westviewgolfcars.com/'

      return (
        <>
          <Helmet title={pageTitle}>
            {/* Google Analytics */}
            <script
              async
              src="https://www.googletagmanager.com/gtag/js?id=UA-175978479-1"
            ></script>
            <script>
              {`
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', 'UA-175978479-1');
            `}
            </script>

            {/* Basic Meta Tags */}
            <meta name="description" content={pageDescription} />
            <meta name="keywords" content={pageKeywords} />
            <meta name="author" content="Westview Golf Cars & More LLC" />
            <meta name="robots" content="index, follow" />
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            <meta charset="utf-8" />

            {/* Google / Search Engine Tags */}
            <meta itemprop="name" content={pageTitle} />
            <meta itemprop="description" content={pageDescription} />
            <meta itemprop="image" content={logoUrl} />

            {/* Facebook Meta Tags */}
            <meta property="og:url" content={siteUrl} />
            <meta property="og:type" content="website" />
            <meta property="og:title" content={pageTitle} />
            <meta property="og:description" content={pageDescription} />
            <meta property="og:image" content={logoUrl} />
            <meta property="og:site_name" content="Westview Golf Cars" />
            <meta property="og:locale" content="en_US" />

            {/* Twitter Meta Tags */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:url" content={siteUrl} />
            <meta name="twitter:title" content={pageTitle} />
            <meta name="twitter:description" content={pageDescription} />
            <meta name="twitter:image" content={logoUrl} />
            <meta name="twitter:site" content="@WestviewGolfCars" />
            <meta name="twitter:creator" content="@WestviewGolfCars" />

            {/* Additional SEO Meta Tags */}
            <meta name="theme-color" content="#e61d30" />
            <meta name="msapplication-TileColor" content="#e61d30" />
            <meta name="apple-mobile-web-app-capable" content="yes" />
            <meta name="apple-mobile-web-app-status-bar-style" content="default" />
            <meta name="apple-mobile-web-app-title" content="Westview Golf Cars" />
            
            {/* Canonical URL */}
            <link rel="canonical" href={siteUrl} />
            
            {/* Favicon and App Icons */}
            <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
            <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
            <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
            <link rel="manifest" href="/site.webmanifest" />
            
            <html lang="en" />
          </Helmet>
          <div className="flex flex-col min-h-screen">
            <HeaderMobile />
            <div className={`flex flex-col flex-grow ${layoutClassName || "relative"}`} id='site-layout' style={layoutStyle || {}}>{children}</div>
          </div>
        </>
      )
    }}
  />
)

export default Layout
